var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 20.8542C5.56417 20.8542 1.14583 16.4358 1.14583 11C1.14583 5.56417 5.56417 1.14583 11 1.14583C16.4358 1.14583 20.8542 5.56417 20.8542 11C20.8542 16.4358 16.4358 20.8542 11 20.8542ZM11 2.52083C6.325 2.52083 2.52083 6.325 2.52083 11C2.52083 15.675 6.325 19.4792 11 19.4792C15.675 19.4792 19.4792 15.675 19.4792 11C19.4792 6.325 15.675 2.52083 11 2.52083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.6667 11.6875H7.33333C6.9575 11.6875 6.64583 11.3758 6.64583 11C6.64583 10.6242 6.9575 10.3125 7.33333 10.3125H14.6667C15.0425 10.3125 15.3542 10.6242 15.3542 11C15.3542 11.3758 15.0425 11.6875 14.6667 11.6875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11 15.3542C10.6242 15.3542 10.3125 15.0425 10.3125 14.6667V7.33333C10.3125 6.9575 10.6242 6.64583 11 6.64583C11.3758 6.64583 11.6875 6.9575 11.6875 7.33333V14.6667C11.6875 15.0425 11.3758 15.3542 11 15.3542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.7786d295adabdf1146530cabf3679d87.svg";
export { ForwardRef as ReactComponent };